/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Follow_Limit_ReachedInputs */

const en_error_follow_limit_reached = /** @type {(inputs: Error_Follow_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already follow 200 objects, the most you can. Unfollow one in your notifications, under Following, then follow this one.`)
};

/**
* | output |
* | --- |
* | "You already follow 200 objects, the most you can. Unfollow one in your notifications, under Following, then follow this one." |
*
* @param {Error_Follow_Limit_ReachedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_follow_limit_reached = /** @type {((inputs?: Error_Follow_Limit_ReachedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Follow_Limit_ReachedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_follow_limit_reached(inputs)
});